import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-elbow-right', 'ArrowElbowRight', [["path",{"d":"M21 14v-6h-6"}],["path",{"d":"M21 8l-9 9l-9 -9"}]]);